import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import PromotionBlock from '../../PromotionBlock/PromotionBlock.js';
import { convertBannerRecommendationInfo } from '../utils/mappers.js';

var BannerRecommendation = /*#__PURE__*/ React__default.forwardRef((_param, ref)=>{
    var { recommendation  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "recommendation"
    ]);
    const info = convertBannerRecommendationInfo(recommendation);
    if (!info) return null;
    let link;
    if (info.action && 'link' in info.action) {
        link = info.action.link;
    }
    return /*#__PURE__*/ React__default.createElement(PromotionBlock, swcHelpers.extends({
        ref: ref,
        id: `banner-recommendation_${info.title}`,
        /**
         * CTA will not show if there's no label. This is not clear from the type.
         */ ctaLabel: (link === null || link === void 0 ? void 0 : link.label) || '',
        size: "small",
        links: swcHelpers.objectSpread({}, link, {
            style: ''
        })
    }, info, rest));
});

export { BannerRecommendation };
//# sourceMappingURL=BannerRecommendation.js.map
